import { create } from "zustand";

/**
 * Auth store — memory-only (NO persist)
 *
 * Access token va user holati faqat xotirada saqlanadi.
 * Reload'da boshlang'ich holatga qaytadi va `App` mount paytida
 * `/api/auth/refresh` (httpOnly cookie orqali) chaqiriladi.
 */

export type TenantRole =
  | "OWNER"
  | "ADMIN"
  | "SALES_LEAD"
  | "MANAGER"
  | "MARKETER"
  | "SUPPORT"
  | "VIEWER"
  | "MEMBER";

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  avatar?: string | null;
  isSuperAdmin?: boolean;
}

export interface TenantSummary {
  id: string;
  slug: string;
  name: string;
  role: string;
  logo?: string | null;
}

export interface AuthSnapshot {
  accessToken: string;
  accessTokenExpiresAt?: string | null;
  user: AuthUser;
  currentTenant: TenantSummary;
  tenants: TenantSummary[];
}

export interface AuthState {
  accessToken: string | null;
  accessTokenExpiresAt: string | null;
  user: AuthUser | null;
  currentTenant: TenantSummary | null;
  tenants: TenantSummary[];
  isHydrating: boolean;
  setAuth: (snapshot: AuthSnapshot) => void;
  setAccessToken: (token: string, expiresAt?: string | null) => void;
  setHydrating: (value: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  accessTokenExpiresAt: null,
  user: null,
  currentTenant: null,
  tenants: [],
  isHydrating: true,

  setAuth: (snapshot) =>
    set({
      accessToken: snapshot.accessToken,
      accessTokenExpiresAt: snapshot.accessTokenExpiresAt ?? null,
      user: snapshot.user,
      currentTenant: snapshot.currentTenant,
      tenants: snapshot.tenants,
      isHydrating: false,
    }),

  setAccessToken: (token, expiresAt = null) =>
    set({
      accessToken: token,
      accessTokenExpiresAt: expiresAt,
    }),

  setHydrating: (value) => set({ isHydrating: value }),

  clear: () =>
    set({
      accessToken: null,
      accessTokenExpiresAt: null,
      user: null,
      currentTenant: null,
      tenants: [],
      isHydrating: false,
    }),
}));

/** Selector — interceptor uchun token sinxron o'qish */
export const getAccessToken = () => useAuthStore.getState().accessToken;
